import React, { useState, useEffect } from "react";
import "./StockManager.css";

const StockManager = () => {
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState("");
  const [quantity, setQuantity] = useState(0);

  // Fetch items from the backend
  useEffect(() => {
    fetch("https://stock-y6ui.onrender.com/api/items")
      .then((response) => response.json())
      .then((data) => setItems(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const addItem = () => {
    if (newItem && quantity > 0) {
      fetch("https://stock-y6ui.onrender.com/api/items", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newItem, quantity }),
      })
        .then((response) => response.json())
        .then((data) => setItems([...items, data]))
        .catch((error) => console.error("Error adding item:", error));
      setNewItem("");
      setQuantity(0);
    }
  };

  const updateQuantity = (id, newQuantity) => {
    fetch(`https://stock-y6ui.onrender.com/api/items/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quantity: newQuantity }),
    })
      .then((response) => response.json())
      .then((updatedItem) => {
        const updatedItems = items.map((item) =>
          item.id === updatedItem.id ? updatedItem : item
        );
        setItems(updatedItems);
      })
      .catch((error) => console.error("Error updating item:", error));
  };

  const deleteItem = (id) => {
    fetch(`https://stock-y6ui.onrender.com/api/items/${id}`, {
      method: "DELETE",
    })
      .then((response) => response.json())
      .then((deletedItem) => {
        const updatedItems = items.filter((item) => item.id !== deletedItem.id);
        setItems(updatedItems);
      })
      .catch((error) => console.error("Error deleting item:", error));
  };

  return (
    <div className="stock-manager">
      <div className="input-section">
        <input
          type="text"
          placeholder="Item Name"
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
        />
        <input
          type="number"
          placeholder="Quantity"
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value))}
        />
        <button onClick={addItem}>Add Item</button>
      </div>
      <ul className="item-list">
        {items.map((item) => (
          <li key={item.id} className="item">
            <span>{item.name}</span>
            <span>{item.quantity}</span>
            <div className="buttons">
              <button
                onClick={() => updateQuantity(item.id, item.quantity + 1)}
              >
                +
              </button>
              <button
                onClick={() => updateQuantity(item.id, item.quantity - 1)}
              >
                -
              </button>
              <button
                className="delete-button"
                onClick={() => deleteItem(item.id)}
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StockManager;
